import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import indexStyles from '../styles/components/index-page.module.scss';

const IndexPage = ({ heroPic } ) => (
  <div className={indexStyles.index}>
    <figure className={indexStyles.hero}>
      <Img fluid={heroPic} alt={'colonia-door'} />
    </figure>
    <h1>Explore Uruguay</h1>
    <p>Uruguay is pretty cool</p>
    <div className={indexStyles.button_group}>
      <Link to={'/articles'}>
        Read articles
      </Link>
      <Link to={'/things-to-do'}>
        Find activities
      </Link>
       <Link to={'/uruguay/guide'}>
        Check out places
       </Link>
    </div>   
  </div>
);

export default IndexPage;
